var map = {
	"./new_h_variant_1.json": [
		77634,
		7634
	],
	"./new_h_variant_2.json": [
		55230,
		5230
	],
	"./new_h_variant_3.json": [
		67245,
		7245
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95526;
module.exports = webpackAsyncContext;